<div class="marker-circle" [style.background]="color"></div>
